import { Box, Dialog } from '@mui/material';
import { CodeViewer } from './Solution';

import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import TabSwitch from 'components/TabSwitch';
import Footer from './Footer';

const ExpandedCodeViewer = ({
  open,
  onClose,
  code,
  decoded,
  activeTab,
  setActiveTab,
  questionTab,
  setQuestionTab,
  setOpenExpandedCode,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      PaperProps={{
        sx: {
          height: '90vh',
          width: '90vw',
          borderRadius: 2,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Box p={5} display="flex" justifyContent="space-between">
        <TabSwitch
          width="336px"
          height={48}
          options={[
            { id: 0, label: 'Optimal solution' },
            { id: 1, label: 'Your response' },
          ]}
          value={activeTab}
          onChange={(e) => setActiveTab(e.id)}
        />
        {activeTab === 1 && (
          <TabSwitch
            width="336px"
            height={48}
            options={[
              { id: 0, label: 'Q1', tooltip: 'Question 1' },
              { id: 1, label: 'F1', tooltip: 'Follow Up 1' },
              { id: 2, label: 'F2', tooltip: 'Follow Up 2' },
            ]}
            value={questionTab}
            onChange={(e) => setQuestionTab(e.id)}
          />
        )}
      </Box>

      <Box flex={1} overflow="hidden">

        <CodeViewer
          decoded={decoded}
          width="100%"
          Icon={{
            icon: <CloseFullscreenIcon />,
            onClick: () => setOpenExpandedCode(false),
          }}
          code={code}
        />
      </Box>

      <Footer
        items={[
          {
            content: '*Questions 2 and 3 follow up on Question 1, leading to one optimal solution.',
            type: 'default',
            hide: false,
          },
        ]}
        sx={{ paddingTop: '4px', paddingBottom: '4px' }}
      />
    </Dialog>
  );
};

export default ExpandedCodeViewer;
